module.exports = __webpack_public_path__ + "img/portada3.51cfebf7.svg";